import { YearInput } from '@amelio/ui-library';

import { HORIZON_YEARS_AHEAD, horizonDateOf, horizonYearOf } from './careerStepValidation';
import { GROWTH_FIELD_BORDER } from './growthStyles';

import { useAmelioTranslations } from '@/hooks';

interface HorizonYearInputProps {
    /** The horizon as the API stores it, an ISO date; `null` while none is aimed at. */
    value: string | null;
    onChange: (value: string | null) => void;
    dataTestId: string;
}

/** The year a target position is aimed at, which the reader may leave open. */
export const HorizonYearInput = ({ value, onChange, dataTestId }: HorizonYearInputProps) => {
    const { t } = useAmelioTranslations();
    const label = t('performanceProfile.growth.stepsEditor.horizonOptional');

    return (
        <YearInput
            value={horizonYearOf(value)}
            onChange={(year) => onChange(horizonDateOf(year))}
            toYear={new Date().getFullYear() + HORIZON_YEARS_AHEAD}
            clearable
            clearLabel={t('performanceProfile.growth.stepsEditor.clearHorizon')}
            placeholder={label}
            ariaLabel={label}
            triggerBorderClassName={GROWTH_FIELD_BORDER}
            dataTestId={dataTestId}
        />
    );
};
